import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DrugIcd } from '@fusion-advantage/backcompat'
import _ from "lodash"
import { FormRootState } from './formStore'
import { ClaimDiagnosisCodeMap, DrugDisposal, OncologyReviewItem, UlcerReviewItem } from '@fusion-advantage/formlib'

export interface FormModelSliceState {
	claimHistory: ClaimDiagnosisCodeMap[]
	drugDisposal: DrugDisposal[]
	drugIcd: DrugIcd[]
	oncologyReview: OncologyReviewItem[]
	ulcerReview: UlcerReviewItem[]
}

const initialState: FormModelSliceState = {
	claimHistory: [],
	drugDisposal: [],
	drugIcd: [],
	oncologyReview: [],
	ulcerReview: [],
}

const formModelSlice = createSlice({
	name: 'formModel',
	initialState,
	reducers: {
		setFormModelClaimHistory(state, action: PayloadAction<ClaimDiagnosisCodeMap[]>) {
			state.claimHistory = action.payload
		},
		setFormModelDrugDisposal(state, action: PayloadAction<DrugDisposal[]>) {
			state.drugDisposal = action.payload
		},
		setFormModelDrugIcd(state, action: PayloadAction<DrugIcd[]>) {
			state.drugIcd = action.payload
		},
		setFormModelOncologyReview(state, action: PayloadAction<OncologyReviewItem[]>) {
			state.oncologyReview = action.payload
		},
		setFormModelUlcerReview(state, action: PayloadAction<UlcerReviewItem[]>) {
			state.ulcerReview = action.payload
		},
	}
})

export const {
	setFormModelClaimHistory,
	setFormModelDrugDisposal,
	setFormModelDrugIcd,
	setFormModelOncologyReview,
	setFormModelUlcerReview,
} = formModelSlice.actions
export default formModelSlice.reducer

export const selectDrugIcdsByCode = createSelector(
	(state: FormRootState) => state.formModel.drugIcd,
	(list) => _.keyBy(list, item => item.Icd10Code)
)
